<!-- <div class="relative">

  <button [class]="class" class="flex items-center justify-end" (click)="toggleDropdown()">
    <ng-content select="[multi-select-icon]"></ng-content>

  </button>


  <div *ngIf="showDropdown" [ngStyle]="{'width': boxSize ? boxSize + 'px' : '100%'}" class="absolute z-10 mt-1 bg-white rounded-md shadow-lg p-3">
    <ul class="overflow-auto mt-2">
      <li *ngFor="let option of options; let i = index" (click)="selectOption(option)"
          [ngClass]="{
            'bg-gray-100 hover:bg-gray-200': i % 2 === 0,
            'bg-white hover:bg-gray-100': i % 2 !== 0
          }"
          class="flex items-center px-4 py-2 cursor-pointer hover:rounded-md transition-colors duration-150 ease-in-out">
        <div class="rounded-full border-2 border-gray-300 mr-2"
             style="width: 20px; height: 20px;">
        </div>
        <span class="ml-2 flex-grow">{{ option[labelKey] }}</span>
        <ng-container *ngTemplateOutlet="extraContentTemplate; context: {$implicit: option}"></ng-container>
      </li>
    </ul>

  </div>
</div> -->

<div class="relative inline-block text-left">
  <button
    [class]="class"
    class="flex items-center justify-end"
    (click)="toggleDropdown()"
  >
    <ng-content select="[multi-select-icon]"></ng-content>
  </button>

  <div
    *ngIf="showDropdown"
    [ngStyle]="{ width: boxSize ? boxSize + 'px' : '100%' }"
    class="origin-top-right absolute right-0 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-gray-700"
  >
    <ul class="py-1 border-none">
      <li
        *ngFor="let option of options; let i = index"
        (click)="selectOption(option)"
        [ngClass]="{
          'border border-b border-gray-50 hover:bg-gray-100 dark:bg-gray-800':
            i % 2 === 0,
          'bg-white hover:bg-gray-100 hover:bg-gray-100 dark:bg-gray-700':
            i % 2 !== 0
        }"
        class="flex items-center px-4 py-2 cursor-pointer border-none transition-colors duration-150 ease-in-out"
      >
        <span class="ml-2 flex-grow dark:text-gray-100">{{
          option[labelKey]
        }}</span>
        <ng-container
          *ngTemplateOutlet="
            extraContentTemplate;
            context: { $implicit: option }
          "
        ></ng-container>
      </li>
    </ul>
  </div>
</div>
